export default __webpack_public_path__ + "media/images/archetypes/lurker-f4c38fa4955e0cbaaaee57d66277b76d.png";